import { render, staticRenderFns } from "./iconP7.vue?vue&type=template&id=1aff33a4&scoped=true&"
import script from "./iconP7.vue?vue&type=script&lang=js&"
export * from "./iconP7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aff33a4",
  null
  
)

export default component.exports